import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-row"
}
const _hoisted_2 = { class: "buttons" }

import ServiceTable from "@/components/tables/ServiceTable.vue";
import { useVfm } from "vue-final-modal";
import CreateServiceModal from "@/components/modals/CreateServiceModal.vue";
import EditServiceModal from "@/components/modals/EditServiceModal.vue";
import { onMounted, reactive } from "vue";
import { useSettingsStore } from "@/stores/setting";
import ServiceDetail from "@/components/services/ServiceDetail.vue";
import Loader from "@/components/util/Loader.vue";
import ConfirmModal from "@/components/modals/ConfirmModal.vue";
import ServiceTeamsList from "@/components/service_teams/ServiceTeamsList.vue";
import TileCard from "@/components/util/TileCard.vue";
import { useServiceTeamsStore } from "@/stores/serviceTeams";
import CreateTeamModal from "@/components/service_teams/dialogs/CreateTeamModal.vue";
import { ServiceTeamItem } from "@/services/entities/ServiceTeams/ServiceTeamItem";
import { ServiceItem } from "@/services/entities/ServiceItem"


export default /*@__PURE__*/_defineComponent({
  __name: 'ServicesView',
  setup(__props) {

const settingsStore = useSettingsStore();
const serviceModalId = Symbol("serviceModalId");
const editServiceModalId = Symbol("editServiceModalId");
const confirmModalId = Symbol("confirmModalId");
const createTeamModalId = Symbol("createTeamModalId");
const teamsStore = useServiceTeamsStore();
const vfm = useVfm();

const state = reactive({
  detail: null,
  teams: null,
  deleteService: "",
  newTeam: {service: {} as ServiceItem } as  ServiceTeamItem,
});

onMounted(async () => {
  await settingsStore.loadServices();
  await teamsStore.loadServiceTeams();
});

function confirmDelete() {
  vfm.close(confirmModalId);
  deleteService();
}

function openDeleteServiceModal(serviceId: string) {
  state.deleteService = serviceId;
  vfm.open(confirmModalId);
}

async function deleteService() {
  await settingsStore.deleteService(state.deleteService);
  state.detail = null;
  state.newTeam.service.id = -1;
}

function showServiceDetail(serviceId: any) {
  state.teams = null;
  state.newTeam.service.id = serviceId;
  state.detail = settingsStore.getServices.find((a) => a.id == serviceId) as any;
}

function showTeams(serviceId: any) {
  state.detail = null;
  state.newTeam.service.id = serviceId;
  state.teams = teamsStore.getServiceTeams.filter((t) => t.service.id === serviceId) as any;
}

async function reload(serviceId: any) {  
  await teamsStore.loadServiceTeams();
  state.teams = teamsStore.getServiceTeams.filter((t) => t.service.id === serviceId) as any;  
}

async function onCreateNewTeam() {
    vfm.close(createTeamModalId);
    teamsStore.createServiceTeam(state.newTeam);
    reload(state.newTeam.service.id);
}

function closeCreateTeam() {
    vfm.close(createTeamModalId);
}

function onCreateTeamClick() {
    vfm.open(createTeamModalId);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(settingsStore).getServicesLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(TileCard, {
            id: "service-table",
            class: "tile-card",
            loaded: _unref(settingsStore).getServicesLoaded
          }, {
            body: _withCtx(() => [
              _createVNode(ServiceTable, {
                data: _unref(settingsStore).getServices,
                onTeams: showTeams,
                onDetail: showServiceDetail
              }, null, 8, ["data"]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("button", {
                  class: "accent",
                  onClick: _cache[0] || (_cache[0] = () => _unref(vfm).open(_unref(serviceModalId)))
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("b", null, "+", -1),
                  _createTextVNode("Create service ", -1)
                ]))])
              ])
            ]),
            _: 1
          }, 8, ["loaded"]),
          _createVNode(TileCard, {
            class: "d-column tile-card",
            loaded: true
          }, {
            body: _withCtx(() => [
              (state.detail)
                ? (_openBlock(), _createBlock(ServiceDetail, {
                    key: 0,
                    service: state.detail,
                    onEdit: _cache[1] || (_cache[1] = () => _unref(vfm).open(_unref(editServiceModalId))),
                    onDelete: openDeleteServiceModal
                  }, null, 8, ["service"]))
                : (state.teams)
                  ? (_openBlock(), _createBlock(ServiceTeamsList, {
                      key: 1,
                      data: state.teams,
                      onReload: reload,
                      onCreateNew: onCreateTeamClick
                    }, null, 8, ["data"]))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createBlock(Loader, { key: 1 })),
    _createVNode(CreateServiceModal, {
      "modal-id": _unref(serviceModalId),
      onClose: _cache[2] || (_cache[2] = () => _unref(vfm).close(_unref(serviceModalId)))
    }, null, 8, ["modal-id"]),
    _createVNode(EditServiceModal, {
      value: state.detail,
      "modal-id": _unref(editServiceModalId),
      onClose: _cache[3] || (_cache[3] = () => _unref(vfm).close(_unref(editServiceModalId))),
      onService: state.detail
    }, null, 8, ["value", "modal-id", "onService"]),
    _createVNode(ConfirmModal, {
      "modal-id": _unref(confirmModalId),
      text: "Do you realy want to delete this service?",
      "confirm-text": "Delete",
      onConfirm: confirmDelete,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_unref(vfm).close(_unref(confirmModalId))))
    }, null, 8, ["modal-id"]),
    _createVNode(CreateTeamModal, {
      team: state.newTeam,
      "modal-id": _unref(createTeamModalId),
      onClose: closeCreateTeam,
      onCreate: onCreateNewTeam
    }, null, 8, ["team", "modal-id"])
  ], 64))
}
}

})